// Обработка отправки сообщений в поддержку
window.Tickets = (function () {

    const selectors = {
        ticketsText: ".j-ticket-text",
        ticketsSubmitButton: ".j-ticket-submit"
    };

    const disabledClass = 'm-disabled';

    // Деактивируем кнопку "Отправить", если ввод пуст
    $(document).on('input', selectors.ticketsText, function () {
        if ($(this).val().length === 0)
            $(selectors.ticketsSubmitButton).addClass(disabledClass);
        else
            $(selectors.ticketsSubmitButton).removeClass(disabledClass);
    });

    const clear = function () {
        $(selectors.ticketsText).val('');
        $(selectors.ticketsText).trigger('input');
    }

    return {
        clear
    };
}());